export default Object.freeze({
  New: 1,
  Submitted: 2,
  Aproved: 5,
  Denied: 6,
  Signed: 7,
  Canceled: 8,
  Amended: 9,
});
